export const VERSION = '0.0.2-beta'
